(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fr-product-description"]) return;
  try {
    
  (function(){
    function init(scope){
      scope.querySelectorAll('[data-frpi]').forEach(function(root){
        if(root.dataset.ready)return;root.dataset.ready='true';
        var select=root.querySelector('[data-frpi-select]'),feedback=root.querySelector('[data-frpi-feedback]');
        if(select&&feedback)select.addEventListener('change',function(){
          if(!select.value){feedback.hidden=true;feedback.textContent='';return;}
          var confirmed=select.options[select.selectedIndex].dataset.compatible==='true';
          feedback.dataset.state=confirmed?'confirmed':'unknown';feedback.textContent=(confirmed?root.dataset.matchMessage:root.dataset.unknownMessage).replace('[model]',select.value);feedback.hidden=false;
        });
        var button=root.querySelector('[data-frpi-show-models]'),chips=root.querySelector('[data-frpi-chips]');
        if(button&&chips)button.addEventListener('click',function(){var expanded=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(expanded));chips.dataset.expanded=String(expanded);button.querySelector('span').textContent=expanded?root.dataset.lessLabel:root.dataset.allLabel;});
        var media=window.matchMedia('(max-width:749px)');
        function layout(){root.querySelectorAll('[data-frpi-collapsible]').forEach(function(details){details.open=!media.matches;});}
        layout();media.addEventListener('change',layout);
        root.querySelectorAll('[data-frpi-collapsible]>summary').forEach(function(summary){summary.addEventListener('click',function(event){if(!media.matches)event.preventDefault();});});
      });
      updateReviews();
    }
    var reviewFrame=0;
    function scheduleReviews(){
      if(reviewFrame)return;
      reviewFrame=window.requestAnimationFrame(function(){reviewFrame=0;updateReviews();});
    }
    function readWebwinkelKeur(){
      var sourceSelector='a[href*="webwinkelkeur.nl/webshop/fatbikesreparatie-nl_1223485"]';
      var widgets=Array.from(document.querySelectorAll('.wwk-sidebar '+sourceSelector));
      var sources=widgets.length?widgets:Array.from(document.querySelectorAll(sourceSelector)).filter(function(el){return !el.closest('[data-frpi]');});
      for(var i=0;i<sources.length;i++){
        var text=(sources[i].textContent||'').replace(/\s+/g,' ');
        var score=text.match(/(10|[0-9])[,.]([0-9])/);
        if(!score)continue;
        var number=Number(score[1]+'.'+score[2]);if(number<1||number>10)continue;
        var count=(text.match(/\(([0-9][0-9., ]*)\)/)||text.match(/([0-9][0-9., ]*)\s*(?:reviews|beoordelingen|bewertungen)/i)||[])[1];
        return {score:score[1]+','+score[2],count:count?count.trim():''};
      }
      return null;
    }
    function updateReviews(){
      var current=readWebwinkelKeur();if(!current)return;
      document.querySelectorAll('[data-frpi]').forEach(function(root){
        root.querySelectorAll('[data-frpi-rating-score]').forEach(function(el){var score=current.score+'/10';if(el.textContent!==score)el.textContent=score;});
        root.querySelectorAll('[data-frpi-rating-tail]').forEach(function(el){var tail=current.count?' · '+current.count+'+ '+root.dataset.reviewWord:'';if(el.textContent!==tail)el.textContent=tail;});
        root.querySelectorAll('[data-frpi-review-sentence]').forEach(function(el){var sentence=root.dataset.reviewSentence.replace('[score]',current.score);if(el.textContent!==sentence)el.textContent=sentence;});
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
    document.addEventListener('shopify:section:load',function(){init(document);});
    window.setTimeout(updateReviews,1000);window.setTimeout(updateReviews,3000);window.setTimeout(updateReviews,8000);
    var reviewsObserver=new MutationObserver(function(records){
      var changed=records.some(function(record){
        var target=record.target.nodeType===1?record.target:record.target.parentElement;
        if(!target||target.closest('[data-frpi]'))return false;
        if(target.closest('.wwk-sidebar,a[href*="webwinkelkeur.nl/webshop/"]'))return true;
        return Array.from(record.addedNodes).some(function(node){
          return node.nodeType===1&&(node.matches('.wwk-sidebar,a[href*="webwinkelkeur.nl/webshop/"]')||node.querySelector('a[href*="webwinkelkeur.nl/webshop/"]'));
        });
      });
      if(changed)scheduleReviews();
    });
    reviewsObserver.observe(document.documentElement,{childList:true,subtree:true,characterData:true});
    window.addEventListener('focus',scheduleReviews);
    document.addEventListener('visibilitychange',function(){if(!document.hidden)scheduleReviews();});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
